import moment from 'moment';

export const formatDate = (format) => {
	return moment().format(format);
}

export const getCurrentYear = () => {
	return formatDate('YYYY');
}

export const formatDateNoTimezone = (date, format) => {
	if (date) {
		let newDate = date;
		if (newDate.indexOf('T') !== -1) {
			newDate = newDate.substring(0, newDate.indexOf('T'));
		}
		return moment(newDate).format(format);
	}
	return '';
};

export const dateFormatter = (date) => {
    if (date) {
      let newDate = date;
      if (newDate.indexOf('T') !== -1) {
        newDate = newDate.substring(0, newDate.indexOf('T'));
      }
      return moment(newDate).format("YYYY-MMMM-DD");
    }
    return '';
  };

export const datetimeFormatter = (datetimeStr) => {
    if (!datetimeStr) { return ''; }

    const date = new Date(datetimeStr);
    return moment(date).format("YYYY-MMM-DD hh:mm:ss A");
};

